import { all, takeLatest, call, put } from 'redux-saga/effects';

import { UNRATE, FINISHED } from '@coconut/constants/questions';

import {
  types,
  fetchCompletedQuestionsSuccess,
  fetchCompletedQuestionsFailed,
} from '../redux/completedQuestions';
import * as apis from '../apis/questions';

function* fetchCompletedQuestionsFlow(action) {
  const { userId, searchIds } = action.payload;

  try {
    const response = yield call(apis.fetchQuestions, {
      userId,
      searchIds,
      statuses: [FINISHED, UNRATE],
    });

    const {
      data: {
        questions,
        current_page: currentPage,
        history_question_count: count,
      },
    } = response;

    const hasUnread = questions.some((question) => !question.is_read);

    yield put(
      fetchCompletedQuestionsSuccess({
        questions,
        currentPage,
        hasUnread,
        count,
      })
    );
  } catch (err) {
    yield put(fetchCompletedQuestionsFailed(err.message));
  }
}

export default function* () {
  yield all([
    takeLatest(types.FETCH_COMPLETED_QUESTIONS, fetchCompletedQuestionsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Home/services/sagas/completedQuestions.js